//const apiUrl = "http://pedidosapp.ddns.net:5002/api";
//const apiUrl = "http://192.168.15.68:5002/api";
//const apiUrl = "http://localhost:5002/api";
//const apiUrl = "https://localhost:5001/api";
//const apiUrl = "http://192.168.15.254:5002/api";

//Servidor producao local
//const apiUrl = "https://gatewaysistemas-app.ddns.net:4443/GwayProducao/api";

//Teste em homologacao
//const apiUrl = "https://vps52074.publiccloud.com.br/apihomologacao/api";

//Producao
const apiUrl = "https://vps52074.publiccloud.com.br/apiproducao/api";

//const whatsappApiUrl = "http://192.168.15.68:3333";
//const whatsappApiUrl = "http://localhost:3333";
const whatsappApiUrl = "https://vps52074.publiccloud.com.br/apiwhatsapp";

const whatsappApiKey = "dev-secret";

export { apiUrl, whatsappApiUrl, whatsappApiKey };

export default apiUrl;
